import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Swal from "sweetalert2";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";

const EditLeaveType = ({ editObj }) => {
  const [editObjData, setEditObjData] = useState({
    id: "",
    lvtype: "",
    lvcode: "",
  });
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
    console.log(superIdData);
  }, []);

  useEffect(() => {
    if (editObj) {
      setEditObjData({
        id: editObj.Id || "",
        lvtype: editObj.LvType || "",
        lvcode: editObj.LvCode || "",
      });
    }
  }, [editObj]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    setloading(true);
    if (tokenData) {
      if (!editObjData.lvtype || !editObjData.lvcode) {
        Swal.fire(
          "Warning",
          "Please fill both Name and Abbreviation",
          "warning"
        );
        return;
      }

      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/leave/updateLeaveTypes`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
            body: JSON.stringify({
              id: editObjData.id,
              lvtype: editObjData.lvtype,
              lvcode: editObjData.lvcode,
            }),
          }
        );

        const data = await response.json();

        if (data.status) {
          Swal.fire({
            title: "Success!",
            text: "Leave details updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire("Error", data.Message || "Something went wrong!", "error");
        }
      } catch (error) {
        console.error("Error updating leave type:", error);
        Swal.fire(
          "Error",
          "Error occurred while updating leave type.",
          "error"
        );
      } finally {
        setloading(false);
      }
    }
  };

  return (
    <div>
      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightEditLeaveType"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "20%", maxWidth: "20%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel">Edit LeaveType</h4>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form onSubmit={handleUpdate}>
            <div className="content">
              <div className="row">
                <div className="col-12 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData.lvtype}
                    onChange={(e) =>
                      setEditObjData({ ...editObjData, lvtype: e.target.value })
                    }
                  />
                </div>
                <div className="col-12 mb-3">
                  <label className="form-label">Abbreviation</label>
                  <input
                    type="text"
                    className="form-control"
                    value={editObjData.lvcode}
                    onChange={(e) =>
                      setEditObjData({ ...editObjData, lvcode: e.target.value })
                    }
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-secondary d-flex mt-3 me-2"
                  data-bs-dismiss="offcanvas"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary d-flex mt-3"
                  disabled={loading}
                >
                  {loading ? "Updating..." : " Update"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

EditLeaveType.propTypes = {
  editObj: PropTypes.object.isRequired,
};

export default EditLeaveType;
